export { middlewares, getEnvironmentInstance, ENVIRONMENT_TAG } from './env/env-instance';
export { getRequestor } from './env/requestor';
export { schema } from './env/schema';

// exports all available data hooks produced by overreact-odata

export { useAccount } from './specs/customer/account/__hooks/entity/entity-hook';
export { useGetExtractedBusinessInfo } from './specs/customer/account/get_extracted_business_info/__hooks/calls/action-hook';
export { usePostABTestingFlightLog } from './specs/customer/account/post_a_b_testing_flight_log/__hooks/calls/action-hook';
export { usePostABTestingEventLog } from './specs/customer/account/post_a_b_testing_event_log/__hooks/calls/action-hook';
export { usePrepareAdRecommendation } from './specs/customer/account/campaign/prepare_ad_recommendation/__hooks/calls/action-hook';
